import {
  type DashRouteType,
  URL_APP_ADMIN,
  URL_PUBLIC,
  URL_RETAILER_SCOPED,
} from '@retailer-platform/dashboard/routing'

const URL_RECEIPTS = `${URL_RETAILER_SCOPED}/receipts`
// @hygen:inject scoped-urls

export type DashRouteSet = DashRouteType<'receipts'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  receipts: URL_RECEIPTS,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
